/* eslint-disable react-hooks/exhaustive-deps */
"use client";

import useGetToken from "@/hooks/useGetToken";
import useSocket from "@/hooks/useSocket";
import { useRouter } from "next/navigation";
import { useEffect } from "react";
import { useToast } from "./toast/useToast";

export default function SocketNotificationCustom() {
  const router = useRouter();
  const { decode } = useGetToken();

  const { toast } = useToast();

  const socket = useSocket();

  const handleTo = (
    refId?: number,
    type?:
      | "user"
      | "admin"
      | "other"
      | "messageFormDeveloper"
      | "aspirationCreated"
      | "aspirationUpdated"
      | "aspirationStatusChanged"
      | "aspirationPublished"
  ) => {
    const generateLink = () => {
      switch (type) {
        case "aspirationCreated":
        case "aspirationUpdated":
        case "aspirationPublished":
        case "aspirationStatusChanged":
          return decode?.role !== "user"
            ? `/submission-aspirations/detail/${refId}`
            : `/aspiration/detail/${refId}`;
        default:
          return undefined;
      }
    };
    const link = generateLink();
    if (link && refId) router.push(link);
  };

  useEffect(() => {
    if (!socket) return;
    if (!decode) return;

    const register = () => {
      socket.emit("register_notif", { userId: decode.id }, () => {
        console.log("✅ register_notif");
      });
    };

    socket.on("connect", register);

    socket.on("receive_notification", (data: any) => {
      const audio = new Audio("/assets/audio/notification2.mp3");
      audio
        .play()
        .then(() => {
          toast.info(
            data.titile ?? "Title Notifikasi",
            data.message ?? "Pesan notifikasi",
            {
              action: {
                label: "Buka",
                onClick: () => {
                  handleTo(Number(data.refId), data.type);
                },
              },
              duration: 6000,
            }
          );
        })
        .catch((error) => console.log("Error playing audio:", error));
    });

    return () => {
      socket.off("connect", register);
      socket.off("receive_notification");
    };
  }, [socket, decode, toast, router]);

  return null;
}
